/*
    When a column is grouped MUI internally changes it's field value to __row_group_by_columns_group_{field}__
    We need to extract the {field} part to ensure the grouped column is rendered correctly
*/
export const extractColumnField = (column: string) => {
    const formattedColumn = column.replaceAll('__', '');
    return formattedColumn.replace('row_group_by_columns_group_', ''); //Unsure how to do this with one replace call
};
